(function datepickerCalendarDirectiveDefinition() {
    'use strict';
    angular.module('DatePickerCalendar', [])
        .directive('datePickerCalendar', ['config',
            function datePickerDirective(config) {
                return {
                    restrict: 'E',
                    templateUrl: config.resourceUrl('/directives/date-picker-calendar/date-picker-calendar.html'),
                    scope: {
                        date: '=ngModel',
                        ngRequired: '=',
                        dateFormat: '@',
                        placeholder: '@',
                        minDate: '=',
                        maxDate: '=',
                        options: '='
                    },
                    controller: [
                        '$scope', '$element', '$attrs', '$uibModal', 'config', 'errorsExtend', '$filter',
                        function datePickerCalendarController($scope, $element, $attrs, $modal, config, errors, $filter) {
                            $scope.date = $scope.date === "" ? undefined : $scope.date;

                            if (new Date($scope.date).toLocaleDateString() === new Date(1900, 1, 1).toLocaleDateString()) {
                                $scope.date = undefined;
                            }

                            if ($scope.date != "" && $scope.date != null) {
                                $scope.dt = new Date($scope.date);
                            }

                            $scope.dateOptions = {
                                formatYear: 'yy',
                                startingDay: 1,
                                minDate: $scope.minDate,
                                maxDate: $scope.maxDate,
                                showWeeks: false
                            };

                            // Disable weekend selection
                            function disabled(dt) {
                                var date = dt.date,
                                    mode = dt.mode;
                                return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
                            }

                            $scope.toggleMin = function () {
                                $scope.minDate = $scope.minDate ? null : new Date(1900, 1, 1);
                            };

                            $scope.toggleMin();

                            $scope.open = function () {
                                $scope.popup.opened = true;
                            };

                            $scope.setDate = function (year, month, day) {
                                $scope.dt = new Date(year, month, day);
                            };

                            //Comentado porque provocaba que no se pudiera enviar un valor vacio en un metadato de tipo fecha
                            //$scope.$watch('date', function () {
                            //    if ($scope.dt && !$scope.date) {
                            //        $scope.date = new Date($scope.dt);
                            //    }

                            //    $scope.date = $scope.date === "" ? undefined : $scope.date;
                            //    if (new Date($scope.date).toLocaleDateString() === new Date(1900, 1, 1).toLocaleDateString()) {
                            //        $scope.date = undefined;

                            //    }
                            //    if ($scope.date) {
                            //        if ($scope.date.toString() !== $scope.dt.toString()) {
                            //            $scope.dt = new Date($scope.date);
                            //        }
                            //    }
                            //});

                            $scope.format = $scope.dateFormat;

                            $scope.popup = {
                                opened: false
                            };
                        }
                    ],
                    link: function ($scope) {
                        if ($scope.options) {
                            angular.extend($scope.options, {
                                clearInput: function () {
                                    $scope.dt = undefined;
                                }
                            });
                        }
                    }

                };

            }]);

})();